function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.slice.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/*
 *  Register Trees
 *    Functions to connect with Urth's custom tree app.
 *
 *  Version
 *    1.0.0 - 2020/05/26
 */

import axios from 'axios';
import $ from 'jquery';
import { getQueryParams, escapeString, createCustomer, shopifyPost } from '@process-creative/slate-theme-tools';
var URTH_TREE_API_ENDPOINT = 'https://gobe-tree.herokuapp.com/';

//Tree App Functions
function fetchTotalClaimed() {
  return _fetchTotalClaimed.apply(this, arguments);
}
function _fetchTotalClaimed() {
  _fetchTotalClaimed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _yield$axios$get, data;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return axios.get("".concat(URTH_TREE_API_ENDPOINT, "loyalty?cnt_claimed=true"));
        case 2:
          _yield$axios$get = _context4.sent;
          data = _yield$axios$get.data;
          return _context4.abrupt("return", data.data.claimedCount);
        case 5:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchTotalClaimed.apply(this, arguments);
}
function submitCode(_x) {
  return _submitCode.apply(this, arguments);
} //Selectors
function _submitCode() {
  _submitCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(code) {
    var email,
      params,
      _yield$axios$post,
      data,
      _args5 = arguments;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          email = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
          params = {
            code: code,
            shop: (Shopify || {}).shop
          };
          if (email && email.trim().length) params.email = email;
          _context5.next = 5;
          return axios.post("".concat(URTH_TREE_API_ENDPOINT, "loyalty"), params);
        case 5:
          _yield$axios$post = _context5.sent;
          data = _yield$axios$post.data;
          return _context5.abrupt("return", data.data.code);
        case 8:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _submitCode.apply(this, arguments);
}
var CONTAINER_SELECTOR = '[data-trees-template]';
var LOYALTY_CONTAINER_SELECTOR = '[data-trees-template]';
var LOYALTY_CLAIMED_SELECTOR = '[data-trees-claimed]';

//Form Selectors
var FORM_LOYALTY = '[data-trees-form]';
var FORM_LOYALTY_INPUT_SELECTOR = '[data-trees-input-code]';
var TREE_CODE_ERRORS = '[data-trees-form-errors]';
var FORM_INPUT_GROUP_SELECTOR = '[data-trees-input-group]';
var FORM_EMAIL_INPUT_SELECTOR = '[data-trees-input-email]';
var FORM_LOYALTY_SUBMIT_SELECTOR = '[data-trees-form-submit]';
var FORM_ADD_FIELD = '[data-trees-add-more]';
var TREE_TEMPLATE_REDEEM_SELECTOR = '[data-trees-template-redeem]';
var TREE_TEMPLATE_SUCCESS_SELECTOR = '[data-trees-template-success]';
var TREE_LOGIN_RETURN_INPUT = '[data-tree-login-return-to]';
var TREE_LOGIN_BUTTON = '[data-trees-form-login]';
var TREE_GUEST_SUBMIT = '[data-trees-guest-submit]';
var TREE_LOGIN_FORM_EMAIL = '[data-tree-login-email]';
var TREE_LOGIN_FORM_PASSWORD = '[data-tree-login-password]';

//Create Account Selectors
var TREE_ACCOUNT_CREATE_TOGGLE = '[data-create-account-toggle]';
var TREE_ACCOUNT_CREATE_SUBMIT = '[data-trees-create-account-submit]';
var TREE_ACCOUNT_CREATE_FIRST = '[data-create-account-first]';
var TREE_ACCOUNT_CREATE_LAST = '[data-create-account-last]';
var TREE_ACCOUNT_CREATE_EMAIL = '[data-create-account-email]';
var TREE_ACCOUNT_CREATE_PASSWORD = '[data-create-account-password]';
var TREE_ACCOUNT_CREATE_PASSWORD_CONFIRM = '[data-create-account-password-confirm]';
var TREE_ACCOUNT_CREATE_NEWSLETTER_SUBSCRIBE = '[data-create-account-newsletter-subscribe]';
var TREE_ACCOUNT_ERRORS = '[data-create-account-errors]';

//Success Msg Selectors
var TREE_SUCCESS_NAME_SELECTOR = '[data-tree-success-name]';
var TREE_SUCCESS_REDEEMED_SELECTOR = '[data-tree-success-redeemed]';
var TREE_SUCCESS_TOTAL_SELECTOR = '[data-tree-success-total]';

//Attrs
var TREE_RADIO_ACCOUNT = 'data-trees-radio-account';
var TREE_ACCOUNT_FORM = 'data-trees-account-form';

//Classes
var CLASS_VISIBLE = 'is-visible';
var CLASS_CREATE_VISIBLE = 'is-create-visible';
var CLASS_PASSWORD_ERROR = 'has-password-error';
var CLASS_ERROR = 'has-error';

//Query Params
var PARAM_KEY = 'codes';
var RegisterTrees = /*#__PURE__*/function () {
  function RegisterTrees(container) {
    var _this = this;
    _classCallCheck(this, RegisterTrees);
    this.container = container;
    this.claimed = container.find(LOYALTY_CLAIMED_SELECTOR);
    this.loyaltyForm = container.find(FORM_LOYALTY);
    this.emailInput = container.find(FORM_EMAIL_INPUT_SELECTOR);
    this.submitButton = container.find(FORM_LOYALTY_SUBMIT_SELECTOR);
    this.redeemContainer = container.find(TREE_TEMPLATE_REDEEM_SELECTOR);
    this.successContainer = container.find(TREE_TEMPLATE_SUCCESS_SELECTOR);
    this.accountForm = container.find("[".concat(TREE_ACCOUNT_FORM, "]"));
    this.loginReturnInput = container.find(TREE_LOGIN_RETURN_INPUT);
    this.treeCodeErrors = container.find(TREE_CODE_ERRORS);
    this.loginFormEmail = container.find(TREE_LOGIN_FORM_EMAIL);
    this.loginFormPassword = container.find(TREE_LOGIN_FORM_PASSWORD);
    this.createAccountForm = container.find("[".concat(TREE_ACCOUNT_FORM, "=\"false\"]"));
    this.createAccountFirst = container.find(TREE_ACCOUNT_CREATE_FIRST);
    this.createAccountLast = container.find(TREE_ACCOUNT_CREATE_LAST);
    this.createAccountEmail = container.find(TREE_ACCOUNT_CREATE_EMAIL);
    this.createAccountPassword = container.find(TREE_ACCOUNT_CREATE_PASSWORD);
    this.createAccountEmailConfirm = container.find(TREE_ACCOUNT_CREATE_PASSWORD_CONFIRM);
    this.createAccountNewsletterSubscribe = container.find(TREE_ACCOUNT_CREATE_NEWSLETTER_SUBSCRIBE);
    this.createAccountErrors = container.find(TREE_ACCOUNT_ERRORS);

    //Success Screen Selectors
    this.successName = container.find(TREE_SUCCESS_NAME_SELECTOR);
    this.successRedeemed = container.find(TREE_SUCCESS_REDEEMED_SELECTOR);
    this.successTotal = container.find(TREE_SUCCESS_TOTAL_SELECTOR);
    this.redeemContainer.addClass(CLASS_VISIBLE);

    //Event Listners & Events
    this.checkUrl();
    container.on('click touchend', TREE_LOGIN_BUTTON, function (e) {
      return _this.onLoginClick(e);
    });
    container.on('click touchend', FORM_LOYALTY_SUBMIT_SELECTOR, function (e) {
      return _this.submitCodes();
    });
    container.on('click touchend', FORM_ADD_FIELD, function (e) {
      return _this.onAddFordField(e);
    });
    container.on('click touchend', "[".concat(TREE_RADIO_ACCOUNT, "]"), function (e) {
      return _this.onAccountRadioClick(e);
    });
    container.on('click touchend', TREE_ACCOUNT_CREATE_TOGGLE, function (e) {
      return _this.onCreateFormToggle(e);
    });
    container.on('click touchend', TREE_ACCOUNT_CREATE_SUBMIT, function (e) {
      return _this.onCreateFormSubmit(e);
    });
    container.on('click touchend', TREE_GUEST_SUBMIT, function (e) {
      return _this.onGuestSubmit(e);
    });

    //Check to see if LL has initialised
    this.loyaltyLionCheck = setInterval(function () {
      return _this.checkLoyaltyLion();
    }, 100);
  }
  _createClass(RegisterTrees, [{
    key: "checkLoyaltyLion",
    value: function checkLoyaltyLion() {
      // Do we have the required data from Loyalty Lion ready?
      if (!window.loyaltylion.customer) return;
      // clear the interval to stop the function from being called
      clearInterval(this.loyaltyLionCheck);
      this.currentPoints = window.loyaltylion.customer.pointsApproved;
    }
  }, {
    key: "checkUrl",
    value: function checkUrl() {
      //Run on load to submit codes if we have logged in from this page
      var params = getQueryParams();
      if (!params[PARAM_KEY]) return;
      var codes = params[PARAM_KEY].split(','); //tree code values split by comma
      if (!codes.length) return;
      this.submitCodes(codes);
    }
  }, {
    key: "findFormCodes",
    value: function findFormCodes() {
      //Finds all of the codes currently entered and returns an array.
      var codes = [];
      var inputCode = this.container.find(FORM_LOYALTY_INPUT_SELECTOR);
      inputCode.each(function (i, e) {
        var self = $(e);
        var code = self.val();
        if (code) codes.push(code);
      });
      if (!codes.length) this.treeCodeErrors.html(Language.strings['general.trees_form.errors_no_codes']);
      return codes;
    }
  }, {
    key: "onAccountRadioClick",
    value: function onAccountRadioClick(e) {
      // On click of the radio button for guest users
      var self = $(e.currentTarget);
      var accountStatus = self.attr(TREE_RADIO_ACCOUNT);
      var accountForm = this.container.find("[".concat(TREE_ACCOUNT_FORM, "=\"").concat(accountStatus, "\"]"));
      this.accountForm.removeClass(CLASS_VISIBLE);
      accountForm.addClass(CLASS_VISIBLE);
    }
  }, {
    key: "onCreateFormToggle",
    value: function onCreateFormToggle(e) {
      e.preventDefault();
      this.createAccountForm.toggleClass(CLASS_CREATE_VISIBLE);
    }
  }, {
    key: "onCreateFormSubmit",
    value: function () {
      var _onCreateFormSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
        var self, form, codes, firstName, lastName, email, password, passwordConfirm, isSubscribed, extraData, values, empty, error, customer, x;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              self = $(e.currentTarget);
              form = self.parents('form'); //Form injected by Shopify
              codes = this.findFormCodes();
              if (codes.length) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              firstName = this.createAccountFirst.val();
              this.guestName = firstName;
              lastName = this.createAccountLast.val();
              email = this.createAccountEmail.val();
              password = this.createAccountPassword.val();
              passwordConfirm = this.createAccountEmailConfirm.val();
              isSubscribed = this.createAccountNewsletterSubscribe[0].checked;
              extraData = {
                "customer[accepts_marketing]": isSubscribed
              }; //Check all input fields, add empty class if empty
              values = [firstName, lastName, email, password, passwordConfirm];
              empty = values.some(function (v) {
                return !v.length;
              });
              if (!empty) {
                _context.next = 19;
                break;
              }
              this.createAccountForm.addClass(CLASS_ERROR);
              return _context.abrupt("return");
            case 19:
              if (!(password != passwordConfirm)) {
                _context.next = 22;
                break;
              }
              this.createAccountForm.addClass(CLASS_PASSWORD_ERROR);
              return _context.abrupt("return");
            case 22:
              //Create the customer
              error = null;
              _context.prev = 23;
              _context.next = 26;
              return createCustomer({
                email: email,
                firstName: firstName,
                lastName: lastName,
                password: password
              }, extraData);
            case 26:
              customer = _context.sent;
              _context.next = 32;
              break;
            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](23);
              error = _context.t0 || 'Unknown error occured';
            case 32:
              if (!error) {
                _context.next = 41;
                break;
              }
              x = error;
              if (x.message) x = x.message;
              if (x.reason) x = x.reason;

              //Is this a cooldown error?
              if (!(/many/gi.test(x) || /unknown/gi.test(x) || /reason/gi.test(x))) {
                _context.next = 38;
                break;
              }
              return _context.abrupt("return", this.onCooldown(form, codes));
            case 38:
              //General error
              this.createAccountErrors.html(x);
              this.createAccountErrors.addClass(CLASS_VISIBLE);
              return _context.abrupt("return");
            case 41:
              //Customer Created Successfully!
              this.submitCodes(codes, email);
            case 42:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[23, 29]]);
      }));
      function onCreateFormSubmit(_x2) {
        return _onCreateFormSubmit.apply(this, arguments);
      }
      return onCreateFormSubmit;
    }()
  }, {
    key: "onCooldown",
    value: function onCooldown(form, codes) {
      //This function is called when the form submit is attempted, but Shopify
      //returns a 429 error (calmdown). What we have to do in order to get this to
      //work is do a classic (non ajax) submit;

      //Update the hidden input fields to take us back to this page
      this.updateInputFields(codes);

      //Now submit the form as expected
      form.submit();
    }
  }, {
    key: "onGuestSubmit",
    value: function onGuestSubmit(e) {
      e.preventDefault();
      var codes = this.findFormCodes();
      if (!codes.length) return;
      this.guestName = this.createAccountFirst.val();
      this.submitCodes(codes);
    }
  }, {
    key: "onLoginClick",
    value: function () {
      var _onLoginClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
        var self, form, codes, email, password;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              //User logs in from the page
              e.preventDefault();
              self = $(e.currentTarget);
              form = self.parents('form');
              codes = this.findFormCodes();
              if (!(!codes.length || !this.loginReturnInput.length)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              email = this.loginFormEmail.val();
              password = this.loginFormPassword.val(); //Update the hidden input used in case ajax login fails
              this.updateInputFields(codes);
              form.submit();

              //Build form data
              // let data = {
              //   form_type: 'customer_login',
              //   utf8: "✓",
              //   customer: {
              //     email: email,
              //     password: password
              //   }
              // }

              // //Try to log user in with ajax
              // let error = null;
              // try {
              //   let customer = await shopifyPost('/account/login', data);
              // } catch(e) {
              //   error = e || 'Unknown error occured';
              // }

              // //Was there an error?
              // if(error) {
              //   let x = error;
              //   if(x.message) x = x.message;
              //   if(x.reason) x = x.reason;

              //   //Is this a cooldown error?
              //   if(/many/gi.test(x) || /unknown/gi.test(x) || /reason/gi.test(x) ) {
              //     //Yes...
              //     return this.onCooldown(form,codes);
              //   }

              //   //General error
              //   console.warn(x);
              //   return;
              // }

              // //Successful? Submit our codes
              // this.submitCodes(codes, email);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function onLoginClick(_x3) {
        return _onLoginClick.apply(this, arguments);
      }
      return onLoginClick;
    }()
  }, {
    key: "onTreeRedemption",
    value: function onTreeRedemption(redeemed) {
      // Swap our content to display the success screen
      this.redeemContainer.removeClass(CLASS_VISIBLE);
      this.successContainer.addClass(CLASS_VISIBLE);

      // Update values
      if (this.successName.length && this.guestName.length) this.successName.html(this.guestName);
      if (this.successRedeemed.length) this.successRedeemed.html("<span class=\"odometer\">".concat(redeemed, "</span>"));
      if (this.successTotal.length && this.currentPoints > 0) {
        this.successTotal.html("<span class=\"odometer\">".concat(this.currentPoints + redeemed, "</span>"));
      }
    }
  }, {
    key: "onAddFordField",
    value: function onAddFordField(e) {
      e.preventDefault();
      var inputGroup = this.container.find(FORM_INPUT_GROUP_SELECTOR).last();
      inputGroup.after("\n      <div class=\"c-trees__tree-code-container o-form__input-group is-additional\" data-trees-input-group>\n        <input\n          type=\"text\"\n          name=\"trees[tree-code]\"\n          class=\"c-trees__tree-code o-input\"\n          placeholder=\"".concat(Language.strings['general.trees_form.tree_code'], "\"\n          aria-label=\"").concat(Language.strings['general.trees_form.tree_code'], "\"\n          spellcheck=\"false\"\n          autocomplete=\"off\"\n          autocapitalize=\"off\"\n          data-trees-input-code\n        >\n        <button class=\"c-trees__tree-code-btn o-btn is-icon is-desktop\" data-trees-add-more>\n          <svg class=\"o-icon c-trees__tree-code-btn-icon o-btn__icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13\">\n            <path d=\"M1.1579 6.5H12.842M7 1v11\" stroke=\"#111\" stroke-width=\"2\" fill=\"none\" stroke-linecap=\"square\"/>\n          </svg>\n          ").concat(Language.strings['general.trees_form.add_codes'], "\n        </button>\n      </div>\n    "));
    }
  }, {
    key: "submitCodes",
    value: function () {
      var _submitCodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(codes, email) {
        var redeemed, i, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!email) email = this.emailInput.val();
              _context3.prev = 1;
              if (!codes || !codes.length) codes = this.findFormCodes();
              if (codes.length) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              // let totalValue = await Promise.all(codes.map(async code => {
              //   return await submitCode(code, inputEmail);
              // })).reduce((x, y) => {
              //   return x + y.value;
              // }, 0);
              // Submit codes and calculate our total value
              redeemed = 0;
              i = 0;
            case 7:
              if (!(i < codes.length)) {
                _context3.next = 15;
                break;
              }
              _context3.next = 10;
              return submitCode(codes[i], email);
            case 10:
              res = _context3.sent;
              redeemed += res.value;
            case 12:
              i++;
              _context3.next = 7;
              break;
            case 15:
              if (redeemed > 0) {
                this.onTreeRedemption(redeemed);
              }
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](1);
              // Invalid code / post data / invalid customer etc
              this.treeCodeErrors.html("".concat(_context3.t0.response.data && _context3.t0.response.data.error && _context3.t0.response.data.error.message || 'Something went wrong'));
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 18]]);
      }));
      function submitCodes(_x4, _x5) {
        return _submitCodes.apply(this, arguments);
      }
      return submitCodes;
    }()
  }, {
    key: "updateInputFields",
    value: function updateInputFields(codes) {
      //Update the hidden input used to redirect login attempts
      this.loginReturnInput.val("".concat(window.location.pathname, "?").concat(PARAM_KEY, "=").concat(codes));
    }
  }]);
  return RegisterTrees;
}();
$(document).ready($(CONTAINER_SELECTOR).each(function (i, e) {
  return new RegisterTrees($(e));
}));